export default __webpack_public_path__ + "static/media/posture-logo.3b936ad1.svg";